'use client';

import { c as _c } from "react/compiler-runtime";
import { deDE } from '@clerk/localizations';
import { ClerkProvider, useUser } from '@clerk/nextjs';
import { dark } from '@clerk/themes';
import { deepMerge, useComputedColorScheme } from '@mantine/core';
import { type ComponentProps, type PropsWithChildren, useEffect } from 'react';
import { isPresent } from 'ts-extras';
import { isAllowedRedirectUrl } from '@/app/(public)/auth/auth-utils';
const disableInput = (element: HTMLInputElement) => {
  element.disabled = true;
  element.ariaDisabled = 'true';
};

// Create a MutationObserver instance

const observer = typeof window === 'undefined' ? null : new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {
        // Check if it's the element we're interested in
        if (node.nodeType === Node.ELEMENT_NODE) {
          // disableInput(node as HTMLInputElement);
          // Check all child elements
          (node as HTMLElement).querySelectorAll('.cl-formFieldInput.cl-input.cl-formFieldInput__slug.cl-input__slug.🔒️').forEach(el => {
            disableInput(el as HTMLInputElement);
          });
        }
      });
    }
  });
});
type Appearance = ComponentProps<typeof ClerkProvider>['appearance'];
export const AuthProvider: React.FC<PropsWithChildren<{
  theme?: 'light' | 'dark';
  publishableKey?: string;
}>> = t0 => {
  const $ = _c(9);
  let {
    children,
    publishableKey,
    theme
  } = t0;
  const computedTheme = useComputedColorScheme();
  theme = computedTheme;
  useEffect(_temp2);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [process.env.NEXT_PUBLIC_ORIGIN_WWW, process.env.NEXT_PUBLIC_ORIGIN_RUN].filter(isPresent);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== theme) {
    t2 = deepMerge({
      options: {},
      variables: {
        borderRadius: "4px",
        fontFamily: "var(--mantine-font-family)"
      }
    } satisfies Appearance, theme === "dark" ? {
      theme: dark,
      variables: {
        colorBackground: "rgb(15 15 15)"
      }
    } satisfies Appearance : {} satisfies Appearance);
    $[1] = theme;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = deepMerge(deDE, {
      organizationProfile: {
        invitePage: {
          selectDropdown__role: "Rolle ausw\xE4hlen"
        }
      },
      userProfile: {
        formButtonPrimary__remove: "Entfernen",
        formButtonPrimary__save: "Speichern",
        formButtonReset: "Abbrechen",
        passkeyScreen: {}
      }
    } satisfies typeof deDE);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NextRedirector />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== publishableKey || $[7] !== t2) {
    t5 = <ClerkProvider allowedRedirectOrigins={t1} appearance={t2} localization={t3} publishableKey={publishableKey}>{t4}{children}</ClerkProvider>;
    $[5] = children;
    $[6] = publishableKey;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
const NextRedirector = () => {
  const user = useUser();
  if (typeof window === 'undefined') return null;
  if (user.isLoaded && user.isSignedIn && window.sessionStorage.getItem('__next__')) {
    const next = window.sessionStorage.getItem('__next__');
    window.sessionStorage.removeItem('__next__');
    if (next && isAllowedRedirectUrl(next) && window.location.href !== next) {
      window.location.href = next;
    }
  }
};
function _temp() {
  observer?.disconnect();
}
function _temp2() {
  observer?.observe(document.body, {
    childList: true,
    subtree: true
  });
  return _temp;
}